<template>
  <div>
    <PageHeader/>

    <div class="container mx-auto py-sf-base px-sf-sm md:px-sf-lg lg:px-sf-sm">
      <h2 class="text-2xl mb-sf-lg"><strong>Information zur Verwendung Ihrer Daten</strong></h2>

      <div class="mb-sf-lg">
        <h3 class="text-xl"><strong>Verantwortlicher für die Datenverarbeitung</strong></h3>
        <p class="mb-sf-lg">Verantwortlicher für die Datenverarbeitung ist:</p>
        <p>Allianz Deutschland AG</p>
        <p>Königinstraße 28</p>
        <p>80802 München</p>
      </div>

      <p class="mb-sf-lg">Unseren Datenschutzbeauftragten erreichen Sie unter der oben genannten Postadresse, mit dem
        Zusatz „An den
        Datenschutzbeauftragten“ oder unter der E-Mail-Adresse: datenschutz@allianz.de.</p>

      <div class="mb-sf-lg">
        <h3 class="text-xl"><strong>Zwecke und Rechtsgrundlagen der Datenverarbeitung</strong></h3>
        <p>
          Die Allianz Drucksachenbestellung ermöglicht Ihnen die systemgestützte Bestellung, Download und
          Personalisierung von digitalen Druckstücken. Zur Nutzung der Allianz Drucksachenbestellung werden die von
          Ihnen bereitgestellten Profildaten (z. B. Name (Vorname, Nachname), Mail-Adresse, Geschäftliche Kontaktdaten
          (Adresse), Abteilungs-/Unit-Zugehörigkeit gespeichert und verarbeitet.
        </p>
        <p>Ihre Daten verarbeiten wir auch, wenn es erforderlich ist, um berechtigte Interessen von uns oder von Dritten
          zu wahren.
        </p>

        <p>Dies kann insbesondere der Fall sein:</p>
        <ul class="list-disc list-inside">
          <li>zur Gewährleistung der IT-Sicherheit und des IT-Betriebs, insbesondere auch bei Support-Anfragen und zur
            Weiterentwicklung des Systems
          </li>
          <li>um im Falle rechtlicher Auseinandersetzungen Sachverhalte nachvollziehen und belegen zu können
          </li>
          <li>für Meinungsumfragen</li>
          <li>um die Nutzung der Allianz Drucksachenbestellung statistisch auszuwerten</li>
        </ul>
      </div>

      <p class="mb-sf-lg">Darüber hinaus verarbeiten wir Ihre
        Daten zur Erfüllung gesetzlicher Verpflichtungen (z.B. handels- und steuerrechtlicher Aufbewahrungs- und
        Nachweispflichten).</p>

      <div class="mb-sf-lg">
        <h3 class="text-xl"><strong>Kategorien von Empfängern der personenbezogenen Daten</strong></h3>
        <p>Um Ihnen die Services der Allianz Drucksachenbestellung anbieten zu können, werden Ihre personenbezogenen
          Daten von dem Shop-Betreiber Arvato Supply Chain Solutions SE verarbeitet.</p>
      </div>

      <div class="mb-sf-lg">
        <h3 class="text-xl"><strong>Dauer der Datenspeicherung</strong></h3>
        <p>Grundsätzlich löschen wir Ihre Daten, sobald sie für die oben genannten Zwecke nicht mehr erforderlich sind,
          es sei denn, die vorübergehende Aufbewahrung ist weiterhin notwendig. So speichern wir Ihre Daten aufgrund
          gesetzlicher Nachweis- und Aufbewahrungspflichten, die sich unter anderem aus dem Handelsgesetzbuch und der
          Abgabenordnung ergeben. Die Speicherfristen betragen danach bis zu zehn volle Jahre. Zudem bewahren wir Ihre
          Daten für die Zeit auf, in der Ansprüche gegen unser Unternehmen geltend gemacht werden können (gesetzliche
          Verjährungsfrist von drei oder bis zu dreißig Jahren).</p>
      </div>

      <div class="mb-sf-lg">
        <h3 class="text-xl"><strong>Betroffenenrechte</strong></h3>
        <p>Sie können unter der o.g. Adresse Auskunft über die zu Ihrer Person gespeicherten Daten sowie unter
          bestimmten Voraussetzungen die Berichtigung oder die Löschung Ihrer Daten verlangen. Ihnen kann weiterhin ein
          Recht auf Einschränkung der Verarbeitung Ihrer Daten sowie ein Recht auf Datenübertragbarkeit
          zustehen.&nbsp;</p>
        <p>Daneben haben Sie die Möglichkeit, sich an eine Datenschutzaufsichtsbehörde zu wenden. Die für uns zuständige
          Behörde ist: Das Bayerische Landesamt für Datenschutzaufsicht in Ansbach.</p>
      </div>

      <div class="mb-sf-lg">
        <h3 class="text-xl"><strong>Widerspruchsrecht</strong></h3>
        <p>Verarbeiten wir Ihre Daten zur Wahrung berechtigter Interessen, können Sie dieser Verarbeitung aus Gründen,
          die sich aus Ihrer besonderen Situation ergeben, widersprechen.</p>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '~/components/Page/PageHeader.vue'
import {usePage} from "~/composables";
import {useCustomerStore} from "../modules/customer/stores/customer";

export default {
  name: 'PrivacyPolicy',
  components: {PageHeader},
  layout() {
    const customerStore = useCustomerStore();
    return customerStore.isLoggedIn ? 'default' : 'login'
  },
  setup() {
    const {pageTitle} = usePage()
    pageTitle.value = 'Datenschutz'

    return {}
  },
  head() {
    return {
      title: 'Datenschutz'
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
